import React, { Component } from "react";
import Button from "react-bootstrap-button-loader";
import Dropzone from "react-dropzone";
import LocaleStrings from "Languages";
var Loader = require("react-loaders").Loader;
export default class AllFilesDrop extends Component {
  constructor(props) {
    super(props);

    this.imageCallback = null;

    this.state = {
      imagePreviewUrl: props.imagePreviewUrl,
      filepath: props.filepath,
      fileLoading: false,
    };
    this.resetImage = this.resetImage.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps) {
      if (nextProps.filepath !== "" && this.state.filepath === "") {
        this.setState({ filepath: nextProps.filepath });
      }
    }
  }

  onDropFile = (files) => {
    var that = this;
    let file = files[0];
    that.setState({ fileLoading: true });

    let reader = new FileReader();
    reader.onloadend = () => {
      var item = reader.result;

      let split = file.name.split(".");
      let ext = split.pop();
      let newFname = split.join();

      // Remove special symbols and extra spaces and replace with underscore
      // newFname = "a@A9 8_)  *AÀA(Ań.";
      // let newFnm = newFname.replace(/[^\w\s]/gi, "_");
      var newFnm = newFname.replace(/[^A-Z0-9]/gi, "_");
      let fileName = newFnm + "." + ext;
      // console.log("fileName :- ", fileName);

      var data = { file: item, filename: fileName };

      // console.log("data :- ", data);
      // console.log("Loading file has ended 111");

      that.props.onFileSave(data);
      that.props.onFileChnageLocally(true);
      that.setState({ fileLoading: false });
    };
    reader.readAsDataURL(file);
  };

  resetImage = () => {
    this.setState({ filepath: "" });
    this.props.onFileSave("");
    this.props.onFileChnageLocally(true);
  };

  render() {
    let fileUrl = this.state.filepath;
    let { fileName, fileOld, accept } = this.props;

    var hideDropZoneClass = "";
    var hideControlButton = "hide-feature";

    if (fileUrl && fileUrl !== "file object not found") {
      hideDropZoneClass = "hide-feature";
      hideControlButton = "";
    }

    var aStyle = {
      width: this.props.width,
      height: this.props.height,
      minHeight: 33,
    };

    var dropStyle = {
      width: this.props.width,
      height: this.props.height,
    };

    return (
      <div className="">
        <Dropzone
          onDrop={this.onDropFile}
          accept={accept ? accept : ""}
          multiple={false}
        >
          {({ getRootProps, getInputProps }) => (
            <div
              {...getRootProps()}
              className={`${this.props.className} ${hideDropZoneClass}`}
              style={dropStyle}
            >
              <input {...getInputProps()} />
              {this.props.innerText}
              {this.state.fileLoading ? (
                <Loader
                  type="line-scale-pulse-out-rapid"
                  active
                  className="loader-div"
                />
              ) : (
                ""
              )}
            </div>
          )}
        </Dropzone>
        {fileOld ? (
          <a
            className={`${hideControlButton} theme-color-text`}
            href={`${fileUrl}`}
            target="_blank"
            title="Download"
          >
            <div className="file-name-display" style={aStyle}>
              {fileName}
            </div>
          </a>
        ) : (
          <div
            className={`${hideControlButton} file-name-display theme-color-text`}
            style={aStyle}
          >
            {fileName}
            {this.state.fileFinishedLoading ? <span>loading...</span> : ""}
          </div>
        )}

        <div className={hideControlButton}>
          <Button
            type="button"
            className="btn btn-custom-blue mt-10 "
            onClick={this.resetImage}
          >
            {" "}
            {LocaleStrings.button_upload_new_file}{" "}
          </Button>
          {""}
          <Button
            type="button"
            className="btn i-custom-table-delete bg-white border-danger mt-10 ml-5"
            onClick={this.resetImage}
          >
            <img
              className="i-custom-normal"
              src="../../style/images/custom-icons/shape-1317-copy-3.svg"
            />
          </Button>
        </div>
      </div>
    );
  }
}
